<template>
  <li class="nav-item nav-sublevel team-link d-flex" :title="team.name" v-if="team.name">
    <i class="gripper-icon" v-if="showGripper"></i>
    <router-link
      :class="{
        'router-link-active': isActiveTeam(team.id, false),
        'radial-hover d-block text-truncate': true
      }"
      class="d-flex align-items-center flex-grow-1"
      :to="teamPageLocation"
      :title="teamLabel"
    >
      <i class="goal-icon flex-shrink-0 mr-1" v-if="showIcon"></i>
      <div class="d-flex justify-content-between align-items-center flex-grow-1">
        <span class="text-truncate" v-no-capture>{{ teamLabel }}</span>
        <i
          class="flex-shrink-0 star-symbol"
          :class="isStarred ? 'starred-icon' : 'star-light-dark-icon'"
          :title="isStarred ? 'Unstar Team' : 'Star Team'"
          @click.stop.prevent="handleStar"
        ></i>
      </div>
    </router-link>
  </li>
</template>

<script>
import { CONTEXT_TYPE } from '@/constants/common'
import { goalsTabIds } from '@/constants/goals'
import SidebarMixin from '@/mixins/SidebarMixin'
import { getTeamPageRouteConfig } from '@/utils/navigationConfigs'
import showAPIError from '@/utils/showAPIError'
import { mapActions, mapGetters } from 'vuex'

/**
 * This gives a Team link to be shown in sidebar
 */
export default {
  name: 'TeamLink',
  props: ['team', 'showGripper', 'label', 'showIcon'],
  mixins: [SidebarMixin],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('starred', ['starred']),
    user() {
      return this.$store.getters.user
    },
    teamPageLocation() {
      return getTeamPageRouteConfig({
        orgId: this.orgId,
        teamId: this.team.id,
        entity: goalsTabIds.goals
      })
    },
    orgTeams() {
      return this.$store.getters.userTeamsByOrgId(this.orgId)
    },
    starredItem() {
      return this.starred?.find(
        x => x.contextType === CONTEXT_TYPE.TEAM && x.contextId === this.team.id
      )
    },
    isStarred() {
      return !!this.starredItem
    },
    orgId() {
      return this.team.organizationId
    },
    teamLabel() {
      return this.label || this.team.name
    }
  },
  methods: {
    ...mapActions('starred', ['getStarred', 'star', 'unstar']),
    async handleStar() {
      try {
        if (this.isStarred) {
          await this.unstar({ orgId: this.orgId, starredId: this.starredItem.id })
        } else {
          await this.star({
            orgId: this.orgId,
            contextType: CONTEXT_TYPE.TEAM,
            contextId: this.team.id
          })
        }
        this.getStarred(this.orgId)
      } catch (e) {
        showAPIError(e)
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_hoverStates.scss';
@import 'styles/rearrangableSidebarLinks';

.star-symbol {
  display: none;
}

.team-link:hover .star-symbol {
  display: inline-block;
}

.goal-icon {
  @include dimension(13px, 13px);
}
</style>
